import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { esignatureErrandCommand } from '../../command/esignature-errand.command';
import { EsignatureErrandService } from '../data/esignature-errand.service';

@Injectable()
export class CancelESignErrandCommandHandler implements ICommandHandler {
  constructor(private _service: EsignatureErrandService) {}

  canExecute(command: Command): boolean {
    return command.id === esignatureErrandCommand.cancelESignatureErrand && command.context;
  }

  execute(command: Command): Observable<boolean> {
    return this._service.cancel(command.context.id).pipe(
      map(statusText => {
        command.context.statusText = statusText;
        return true;
      })
    );
  }
}
